import React from "react";
import {
  Card,
  CardHeader,
  CardContent,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography
} from "@material-ui/core";

const currencyFmt = (v, code = "USD") =>
  new Intl.NumberFormat(undefined, { style: "currency", currency: code, maximumFractionDigits: 0 }).format(v || 0);

const formatDate = (value) => {
  if (!value) return "Unknown date";
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(+date)) return "Unknown date";
  return date.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
};

export default function ProfitByInvoiceTable({ invoices = [], currency = "USD", maxRows = 8 }) {
  const rows = (invoices || []).slice(0, maxRows);

  return (
    <Card variant="outlined">
      <CardHeader
        title="Profit by Invoice"
        subheader={rows.length ? `${rows.length} shown` : undefined}
      />
      <CardContent style={{ paddingTop: 0, overflowX: "auto" }}>
        {rows.length === 0 ? (
          <Typography variant="body2" color="textSecondary">
            No invoices in this range.
          </Typography>
        ) : (
          <Table size="small" aria-label="Profit by invoice table">
            <TableHead>
              <TableRow>
                <TableCell>Invoice</TableCell>
                <TableCell>Client</TableCell>
                <TableCell>Date</TableCell>
                <TableCell align="right">Revenue</TableCell>
                <TableCell align="right">Profit</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((inv, idx) => (
                <TableRow key={inv.invoiceId || idx}>
                  <TableCell>{inv.invoiceNumber || inv.invoiceId || "Invoice"}</TableCell>
                  <TableCell>{inv.clientStore || inv.clientName || "—"}</TableCell>
                  <TableCell>{formatDate(inv.accrualDate)}</TableCell>
                  <TableCell align="right">{currencyFmt(inv.amount, currency)}</TableCell>
                  <TableCell align="right">{currencyFmt(inv.profit, currency)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
}
